/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "bar-echart"
};
import BaseEchart from '@/base-ui/echart';
export default /*#__PURE__*/_defineComponent({
  __name: 'bar-echart',
  props: {
    lineData: {},
    xLabels: {},
    legendData: {},
    color: {},
    left: {},
    height: {
      default: '160px'
    },
    grid: {
      default: function _default() {
        return {
          left: 60,
          top: 40,
          bottom: 30,
          right: 20
        };
      }
    },
    labelColor: {
      default: '#999999'
    },
    splitLineColor: {
      default: function _default() {
        return ['#ccc'];
      }
    },
    splitLineType: {
      default: 'solid'
    },
    showBackground: {
      type: Boolean,
      default: true
    },
    customTooltip: {
      type: Boolean,
      default: false
    },
    formatter: {
      type: Function,
      default: function _default(params) {
        console.log(params);
        return undefined;
      }
    },
    legendShow: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var options = computed(function () {
      var option = {
        tooltip: {
          enterable: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: props.legendShow,
          data: props.legendData
        },
        grid: props.grid,
        xAxis: {
          data: props.xLabels,
          axisLabel: {
            // inside: true,
            color: props.labelColor
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          z: 10
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: props.labelColor
            }
          },
          splitLine: {
            lineStyle: {
              color: props.splitLineColor,
              type: props.splitLineType
            }
          }
        },
        dataZoom: [{
          type: 'inside'
        }],
        series: [{
          name: props.legendData[0],
          type: 'bar',
          showBackground: props.showBackground,
          itemStyle: {
            color: props.color
          },
          emphasis: {
            itemStyle: {
              color: props.color
            }
          },
          data: props.lineData
        }
        // {
        //   name: props.legendData[1],
        //   type: 'bar',
        //   showBackground: true,
        //   itemStyle: {
        //     color: '#5AC57F'
        //   },
        //   emphasis: {
        //     itemStyle: {
        //       color: '#5AC57F'
        //     }
        //   },
        //   data: props.lineData2
        // }
        ]
      };
      if (props.customTooltip) {
        option.tooltip.enterable = true;
        option.tooltip.formatter = props.formatter;
      }
      return option;
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(BaseEchart), {
        options: _unref(options),
        height: _ctx.height
      }, null, 8, ["options", "height"])]);
    };
  }
});